import { ISearchParamName, ISearchParamNameAndValue, SearchParamName } from '@cbridge-packages/routing';

export namespace TypeParam {
  export const name: ISearchParamName = {
    name: SearchParamName.AlertType,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}

export namespace FromParam {
  export const name: ISearchParamName = {
    name: SearchParamName.AlertRangeFrom,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}

export namespace ToParam {
  export const name: ISearchParamName = {
    name: SearchParamName.AlertRangeTo,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}
